<template>
  <Section id="closing" tone="accent" pad-y="lg">
    <Container>
      <div class="flex flex-col items-center gap-6 text-center">
        <h2 class="max-w-2xl text-3xl font-extrabold text-ink-inverse md:text-5xl">
          {{ t('sections.closing.title') }}
        </h2>
        <p class="max-w-2xl text-base text-ink-inverse/80 md:text-lg">
          {{ t('sections.closing.subtitle') }}
        </p>
        <div class="flex flex-wrap justify-center gap-3">
          <BaseButton variant="secondary" size="lg" @click.prevent="clickBriefButton">
            {{ t('cta.startBrief') }}
            <template #icon-right>
              <BaseIcon name="arrow-right" :size="20" />
            </template>
          </BaseButton>
          <!--<BaseButton variant="outline-inverse" size="lg" as="router-link" :to="calculatorTo">
            {{ t('cta.tryCalculator') }}
          </BaseButton>-->
        </div>
      </div>
    </Container>
  </Section>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import Section from '@/components/primitives/Section.vue';
import Container from '@/components/primitives/Container.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import BaseIcon from '@/components/base/BaseIcon.vue';
import { useLocale } from '@/composables/useLocale';
import { useRouter } from 'vue-router';
import { yaTrackEvent } from '@/lib/metrics';

const { t } = useI18n();
const { locale } = useLocale();
const router = useRouter();

//const calculatorTo = computed(() => `/${locale.value}/calculator`);

const clickBriefButton = () => {
  yaTrackEvent('NewSiteOpenBrief');
  router.push(`/${locale.value}/brief`);
}
</script>
